import { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { timezoneOptions } from "@/lib/format";

export const TimezoneSelect = ({ value, onChange, disabled, testId = "timezone-select" }) => {
  const zones = useMemo(timezoneOptions, []);
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testId} className="h-11"><SelectValue placeholder="Choose a timezone" /></SelectTrigger>
      <SelectContent className="max-h-72">{zones.map((z) => <SelectItem key={z.value} value={z.value}>{z.label}</SelectItem>)}</SelectContent>
    </Select>
  );
};
